<template>
    <div>
        <app-version-manager />
    </div>
</template>

<script>


import AppVersionManager from '@/components/DataManagement/AppVersion';
import {mapGetters} from "vuex";


export default {
    components : {
        AppVersionManager,
    },
    computed: {
        ...mapGetters({
            features: 'accountFeatures',
        }),
    },
    mounted() {

        // `selectionProcessingUi` -- lowercase `i`, matching the definition in Features.js.
        // This read was `selectionProcessingUI` (capital I), a key that does not exist, so the
        // condition was always undefined and this poller never dispatched. The spinner in
        // Card-Grid.vue reads the correct spelling, which is why a selection showed "Processing
        // Content" forever and only a manual browser refresh ever cleared it.
        setInterval(
            () => {
                if(this.features && this.features.selectionProcessingUi) {
                    this.$store.dispatch('processNextReload')
                }
            },
                15*1000
        );
    }
}
</script>
